import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, type User } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBRs6VbaulBaL8RFNetQiBw127b1th86oQ",
  authDomain: "originstamp-velocity.firebaseapp.com",
  projectId: "originstamp-velocity",
  storageBucket: "originstamp-velocity.firebasestorage.app",
  messagingSenderId: "1040314631766",
  appId: "1:1040314631766:web:636ae20edefd3fce729df7",
};

export const ALLOWED_DOMAIN = "originstamp.com";

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ hd: ALLOWED_DOMAIN });
// Region must match the @https_fn.on_call(region=...) decorator. Callable
// functions are invoked via httpsCallable() — the SDK signs/verifies tokens
// for us, so callers skip the manual Bearer-token plumbing.
export const functions = getFunctions(app, "europe-west6");

// When `VITE_USE_FUNCTIONS_EMULATOR=1` is set (in `web/.env.local`), route
// every callable through the Firebase Functions emulator on
// 127.0.0.1:5001. Auth still uses real Firebase Auth so sign-in works.
if (import.meta.env.VITE_USE_FUNCTIONS_EMULATOR === "1") {
  const host =
    (import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST as string | undefined) ??
    "127.0.0.1";
  const port = Number(
    (import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT as string | undefined) ?? 5001,
  );
  connectFunctionsEmulator(functions, host, port);
  // eslint-disable-next-line no-console
  console.info(`[firebase] using functions emulator at ${host}:${port}`);
}

export const isAllowedUser = (user: User | null): user is User =>
  !!user &&
  typeof user.email === "string" &&
  user.email.endsWith(`@${ALLOWED_DOMAIN}`);
